<template>
  <main class="haze-widget-short">
    <div class="haze-region-slider" v-if="psi">
        <div class="row header">
          <h2>LATEST</h2>
          <div class="updateon">{{formattedLastUpdated}}</div>
          <!-- <a target="_blank" class="full-report" href="full-index.html">See more</a> -->
          <!-- <a class="full-report" target="_self" href="full-index.html" @click="this.$parent.data.fullversion = !this.$parent.data.fullversion" >Show more</a> -->
          <div class="full-report" @click="$emit('toggle-version')" >Show more</div>
        </div>
        <div class="row container">
          <div class="row region">
            <h4>24-hr PSI</h4>
            <div class="row-grid-2">
              <div class="psi">
                <div :class="['box', psi[activeRegion].class]">
                  <animated-number
                    :value="psi[activeRegion].value"
                    :formatted="v => v.toFixed()"
                    :animation="{duration: 0.66667}">
                  </animated-number>
                  <div class="label">{{psi[activeRegion].band.label}}</div>
                </div>
              </div>
              <div class="psi-map">
                <div class="sg-map">
                  <img class="map" :alt="activeRegion + ' Singapore'" src="../assets/images/map.png" />
                  <span @click="setActive(region)" v-for="region in regions" :key="region" :class="getRegionClass(region)">
                    {{psi[region].value}}
                  </span>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <pm-25-chart :data="pm25" :active="activeRegion" class="row"></pm-25-chart>
        </div>

    </div>

  </main>
</template>

<script>
import Pm25Chart from './Pm25Chart'
import AnimatedNumber from './AnimatedNumber'
import {useStore} from '../store'

const MONTHS = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

export default {
  setup () {
    return useStore()
  },
  components: {
    AnimatedNumber,
    Pm25Chart
  },
  data () {
    return {
      activeRegion: 'North',
      // today: this.dateFormat(),
      // tips: [
      //   'When the outdoor air quality appear to be worsening, close doors and windows.',
      //   'Tips two',
      //   'When the outdoor air quality appear to be worsening, close doors and windows. Tips three'
      // ]
      ismobile: true
    }
  },
  computed: {
    formattedLastUpdated () {
      if (!this.lastUpdated) return
      const d = new Date(this.lastUpdated)
      d.setHours(d.getHours() + 8)
      let h = d.getUTCHours()
      const isPM = h >= 12
      h = isPM ? h - 12 : h
      h = h === 0 ? 12 : h
      // return `As at ${h}${isPM ? 'pm' : 'am'} on ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`
      return `As at ${h}${isPM ? 'pm' : 'am'} on ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`
    }
  },
  methods: {
    setActive (region) {
      this.$analytics.track('change region', region)
      this.activeRegion = region
    },
    getRegionClass (region) {
      const {activeRegion, psi} = this
      return [
        'psi-region-value',
        region.toLowerCase(),
        {'active-region': activeRegion === region},
        psi[region].class
      ]
    }
  },
  watch: {
    highest () {
      this.activeRegion = this.highest
    }
  }
}
</script>

<style lang="scss">
$radius: 15px;
$transitiontime: 0.3s;

.haze-widget-short {
  padding: 10px 0;
  box-sizing: border-box;
  * {
    font-family: $font-CuratorRegular;
    font-size: 15px;
  }
  h1, h2, h3, h4 {
    font-family: $font-CuratorBold;
    font-weight: normal;
  }
  h2 {
    line-height: initial;
  }
  .clear {
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
    float: none;
  }
  .hiddden {
    font-size: 0;
    visibility: hidden;
  }
  .row {
    float: none;
    clear: both;
    &-grid {
      @include grid_template(1);
      // &-2 { @include grid_template(2); }
      // &-3 { @include grid_template(3); }
      
      &-2 {
        .psi {
          float: left;
          width: 40%;
        }
        .psi-map {
          float: right;
          width: 60%;
        }
      }

    }
  }
  .health-advisory *, .psi h3 {
    margin: 0;
  }
  .haze-region-slider {
    // padding: 15px;
    h2 {
      margin: 0;
    }
    .header {
      position: relative;
      // max-width: 350px;
      h2 {
        display: inline-block;
        font-size: 22px;
        line-height: 28.8px;
      }
      .updateon {
        display: inline-block;
        font-size: 13px;
        line-height: initial;
        margin-left: 10px;
        opacity: 0.5;
      }
      .full-report {
        font-size: 15px;
        border: 1px solid rgba($black, 0.5);
        cursor: pointer;
        user-select: none;
        color: $black;
        border-radius: $radius;
        outline: none;
        padding: 4px 25px 4px 15px;
        text-decoration: none;
        position: absolute;
        right: 0;
        top: 0;
        line-height: initial;
        box-sizing: border-box;
        transition: $transitiontime;
        &:after {
          content: '';
          background: url(../assets/images/arrow.svg) no-repeat center;
          background-size: 30%;
          position: absolute;
          right: 0;
          bottom: 0;
          width: 20px;
          height: 100%;
          opacity: 0.5;
          transition: $transitiontime;
          margin-right: 1px;
        }
        &:hover {
          border: 1px solid rgba($black, 1);
          &:after {
            opacity: 1;
          }
        }
      }
    }
    .tabs {
      @include grid_template(5);
      padding: 10px;
      box-sizing: border-box;
      max-width: $d_medium;
      margin: 0 auto;
      .tab {
        display: inline-block;
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;
        opacity: 0.4;
        &.active-tab, &:hover {
          opacity: 1;
          transition-duration: $transitiontime;
        }
      }
    }
    .region {
      h4 {
        margin: 0;
        font-size: 15px;
      }
    }
    .container {
      @media  (min-width: ($d_medium + 1)) {
        @include grid_template(2);
      }
    }
    .box {
      position: relative;
      text-align: center;
      color: #ffffff;
      border-radius: $radius;
      width: 100%;
      max-width: 153px;
      height: 140px;
      transition: $transitiontime;
      h1 {
        font-size: 75px;
        line-height: 100px;
        margin: 0;
        box-sizing: border-box;
        position: relative;
        * {
          font-size: 13px;
          line-height: initial;
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      }
      .label {
        position: absolute;
        border-radius: 0 0 $radius $radius;
        transition: background $transitiontime;
        font-size: 15px;
        line-height: 24px;
        padding: 6px 0;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    }
    .psi {
      .box {
        
      }
    }
    // .pm25 {
    //   .box {
    //     background: lighten($greydark, 10%);
    //     .label {
    //       background: $greydark;
    //     }
    //   }
    // }
    .psi-map {
      .sg-map {
        position: relative;
        margin: 0 auto;
        max-width: 100%;
        transition: $transitiontime;
      }
      .map {
        max-width: 100%;
        display: block;
      }
      .psi-region-value {
        font-family: $font-CuratorRegular;
        border-radius: 100%;
        display: table-cell;
        text-align: center;
        vertical-align: middle;
        width: 30px;
        height: 30px;
        font-size: 13px;
        line-height: inherit;
        position: absolute;
        top: 33%;
        left: 43%;
        cursor: pointer;
        transform: translate(-43%, -33%);
        &:hover {
          opacity: 0.8;
        }
        &.active-region, &.active-region:hover {
          border: 1.5px solid $black;
          font-family: $font-CuratorBold;
          opacity: 1;
        }
        &.north {
          top: 6%;
        }
        &.south {
          top: 60%;
        }
        &.west {
          left: 22%;
        }
        &.east {
          left: 63%;
        }
      }
    }
  }
  .good {
    background: #68a94b;
    color: #ffffff;
    .label {
      background: darken(#68a94b, 15%);
    }
  }
  .moderate {
    background: #6b9dcf;
    color: #ffffff;
    .label {
      background: darken(#6b9dcf, 15%);
    }
  }
  .unhealthy {
    background: #f8d448;
    .label {
      background: darken(#f8d448, 15%);
    }
  }
  .very-unhealthy {
    background: #d4883d;
    color: #ffffff;
    .label {
      background: darken(#d4883d, 15%);
    }
  }
  .hazardous {
    background: #dd5034;
    color: #ffffff;
    .label {
      background: darken(#dd5034, 15%);
    }
  }
  .show-mobile {
    display: block;
    @media (min-width: ($d_medium + 1)) {
      display: none;
    }
  }
  .hide-mobile {
    display: none;
    @media (min-width: ($d_medium + 1)) {
      display: block;
    }
  }
  @media (max-width: 350px) {
    .haze-region-slider .header .updateon {
      max-width: 150px;
    }
    .haze-region-slider .header .full-report {
      // top: 30px;
    }
  }
  @media (max-width: $d_medium) {
    .haze-region-slider .tabs {
      padding: 10px 0;
      row-gap: 10px;
      column-gap: 10px;
    }
    .haze-region-slider .tips .tip {
      height: 120px;
    }
    .haze-region-slider .psi {
      width: 30%;
    }
    .haze-region-slider .psi-map {
      width: 65%;
    }
    .haze-region-slider .psi-map .sg-map {
      max-width: 210px;
      margin: 0;
    }
    .haze-region-slider .header .updateon {
      font-size: 13px;
    }
    .haze-region-slider .header .full-report {
      font-size: 13px;
      padding: 4px 20px 4px 10px;
    }
    .haze-region-slider .box {
      max-width: 116px;
      height: 105px;
    }
    .haze-region-slider .box h1 {
      font-size: 56px;
      line-height: 76px;
    }
    .haze-region-slider .box .label {
      font-size: 14px;
      line-height: 18px;
    }
  }
  @media (min-width: $d_medium + 1) {
    .haze-region-slider .psi-map .sg-map {
      max-width: 220px;
      padding: 10px;
      box-sizing: border-box;
    }
    .haze-region-slider .header h2 {
      font-size: 22px;
      line-height: 33.6px;
    }
    .pm-25-chart svg {
      height: 180px;
    }
  }
  @media (min-width: $d_medium + 1) and (max-width: 650px) {
    .haze-region-slider .box h1 {
      font-size: 56px;
    }
    .row-grid-2 .psi-map {
      margin-top: 6%;
    }
  }
}
</style>
